<template>
  <div id="component">
    <div class="method-select">
      Method:
      
      <select v-if="isModelSpecificMethod" class="selector disabled">
        <option selected disabled>
          {{ displayMethod}}
        </option>
      </select>

      <select v-else class="selector" @change="emitMethodChange($event.target.value)">  
        <option :value="null" v-if="displayMethod">
          Clear Method
        </option>

        <option selected disabled :value="null" v-else>
          Select a Method
        </option>

        <option v-for="(_, name, index) in labelToFunction" :key="index" :selected="name === displayMethod">
          {{ name }}
        </option>
      </select>
    </div>

    <div class="description" v-if="method.description.length">
      <b>Description</b>:
      <span>&nbsp;</span>
      {{ method.description }}
    </div>
    
    <table class="param-table">
      <tr
        v-for="(opt, index) in methodParameters" :key="index"
        class="param-row"
      >
        <td class="param-name">
          <b>{{ opt.name }}</b>:
        </td>
        <td class="param-value">
          <InputSelector
            :value="inputMapping.inputMapping[opt.name]"
            :availableComponents="availableComponents"
            @newValue="emitNewValue(opt.name, $event)"
          />
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import InputSelector from '@/components/model/InputSelector';
import { labelToFunction } from '@/js/model/Functions';

const _ = require('lodash');


export default {
  name: 'MethodSelector',
  components: {
    InputSelector
  },
  props: {
    method: Function,
    inputMapping: {type: Object, default: ()=>{}},
    availableComponents: {type: Array, default: ()=>[]},
    scenarios: {type: Array, default: ()=>[]}
  },
  data: function() {
    return {
      labelToFunction: labelToFunction
    }
  },
  computed: {
    displayMethod: function() {
      if (Array.isArray(this.method)) return 'Multiple';
      else return this.method.label;
    },
    displayParameters: function() {
      if (Array.isArray(this.method)) return [];
      else return this.scenarios[0];
    },
    isModelSpecificMethod: function() {
      return !(this.displayMethod in this.labelToFunction);
    },
    methodParameters: function() {
      return this.method.parameters ?? [];
    },
    methodInputLength: function() {
      return this.method.maxInputSize;
    },
    inputStepSize: function() {
      return this.getDefaultStep(this.method.label) ?? 1;
    }
  },
  methods: {
    emitNewValue(option, newValue) {
      this.$emit('adjustParams', {key: option, value: newValue});
    },
    emitMethodChange(newMethod) {
      let methodFunc = labelToFunction[newMethod];
      this.$emit('changeMethod', {method: methodFunc});
    },
    getDefaultStep(method) {
      // Make all defaults 1 for now
      return this.methodParameters.map(_ => 1);
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#component {
  margin: auto;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
}

.method-select, .description, .param-table {
  margin: 5px 0;
}

.selector {
  width: 175px;
}
.selector.disabled {
  background: #c0ccd7;
}


</style>
